export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11478.28107965.jpg";